export default __webpack_public_path__ + "static/media/640_store05-nl-mobile.e85be04f.png";